<section>
  <div class="main-padding">
  <!-- Section 1 -->
  <section class="content" id="info">
    <!-- 1 -->
    <div class="card-body">
      <div class="row">
        <p class="subtitleText">{{ 'HOME.TITLE' | translate }}</p>
      </div>
      <div class="row notice-home">
        <p class="notice" *ngFor="let list of Notice_Data">{{list.date}}&nbsp;&nbsp;{{list.content}}</p>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <a class="btn-pinkmini" (click)="ManualPDF()"><img src="assets/icons/openbook.svg"/> {{ 'HOME.MANUAL_BUTTON' | translate }}</a>
      </div>
    </div>
  </section>
</div>
</section>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#E10800 " type = "square-jelly-box" [fullScreen] = "true">
  <p style="color: #E10800 " > {{ 'COMMON.LOADING' | translate }} </p>>
</ngx-spinner>